import Vue from 'vue'
import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify'
import Axios from "axios";
import router from "./router"

Vue.config.productionTip = false
// Axios.defaults.baseURL = "http://192.168.20.127:8087/";
Axios.defaults.withCredentials = true;

export const bus = new Vue();

new Vue({
  store, router, vuetify, render: h => h(App)
}).$mount('#app')
